import { type IAuth } from "@kunduz/data-access-auth-api";
import { useEffect } from "react";
import { getLocale } from "../localization";
import { SiteLangEnum } from "@kunduz/utility-common";

/**
 * sets language cookie using data from profiles endpoint
 * only run for non-student profiles
 */
export function useProfileLanguage(
  profiles?: IAuth.IVerifyOtpResponse["profiles"],
  setUserLang?: (_lang: SiteLangEnum) => void,
) {
  useEffect(() => {
    if (!profiles) return;
    if (!!profiles.student) return;
    const locale = getLocale({ apiId: profiles.country });

    if (!locale) return;

    setUserLang && setUserLang(locale.i18nextLocale);
  }, [profiles]);

  return {};
}
